module.exports = __webpack_public_path__ + "static/media/support_white.1481a852.svg";